import {
	type PreParsedSectionLinkProps,
	type PreParsedSectionSettingProps,
	type SectionsPageProps,
	useSettings
} from '@capsicum/common';
import styled, { useTheme } from 'styled-components';

import { ActivityIndicator } from '../../atoms/ActivityIndicator';

/**
 * Section page.
 *
 * @param {SectionsPageProps} props - The props of the component
 * @param {Array<PreParsedSectionLinkProps | PreParsedSectionSettingProps>} props.sections The list of sections
 * @param {string} props.testID To locate the element in the testing environment
 * @returns {JSX.Element} The Section page
 */
export const SectionsPage = <T extends PreParsedSectionLinkProps | PreParsedSectionSettingProps>({
	sections,
	testID
}: SectionsPageProps & { testID?: string }) => {
	const { colors } = useTheme();
	const { areSettingsLoading } = useSettings();

	return (
		<S.Wrapper date-testid={testID}>
			{areSettingsLoading ? (
				<S.LoaderWrapper>
					<ActivityIndicator color={colors.icons.brand.enabled} />
				</S.LoaderWrapper>
			) : (
				sections
			)}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			padding-left: ${({ theme }) => theme.spacings.small};
			padding-right: ${({ theme }) => theme.spacings.small};
		}
		padding-top: ${({ theme }) => theme.spacings.medium};
		width: 100%;
	`;

	export const LoaderWrapper = styled.div`
		display: flex;
		justify-content: center;
	`;
}
